import MainLayout from "@/components/layout/applicant/MainLayout.vue";
export default {
    name: "contactUsCreate",
    components: {
        MainLayout
    }
};